<template>
    <b-container v-if="get_next_to_bind" id="bind-batch" fluid>
        <b-row>
            <b-col cols="4">
                <div style="text-align: center">
                    <b-button variant="danger" v-on:click="checkIncoherencesAndBind(true)" :disabled="binding">
                        Valider !
                    </b-button>
                    <b-button variant="info" v-on:click="doRotation(true)" :disabled="binding || is_one_document"
                        title="Presser + pour effectuer une rotation de +90°">
                        Rotation 90° (+)
                    </b-button>
                    <b-button variant="info" v-on:click="doRotation(false)" :disabled="binding || is_one_document"
                        title="Presser - pour effectuer une rotation de -90°">
                        Rotation -90° (-)
                    </b-button>
                    <b-button variant="info" v-on:click="doZoom(true)" :disabled="binding || is_one_document"
                        title="Presser p pour agrandir l'image, 'echap' pour annuler">
                        Zoom plus (p)
                    </b-button>
                    <b-button variant="info" v-on:click="doZoom(false)" :disabled="binding || is_one_document"
                        title="Presser m pour diminuer l'image, 'echap' pour annuler">
                        Zoom moins (m)
                    </b-button>
                    <b-button variant="info" v-on:click="unbind_all = true" title="Détacher tout" :disabled="is_one_document">
                        Détacher tout
                    </b-button>
                    <b-button variant="danger" v-on:click="checkIncoherencesAndBind(false)" :disabled="binding">
                        Valider et STOP WORKING!
                    </b-button>
                    <p v-if="bind_waiting" style="color: green">
                        {{ bind_waiting }}
                    </p>
                    <p v-if="bind_error" style="color: red">
                        {{ bind_error }}
                    </p>
                    <p v-if="bind_error" class="btn btn-warning" v-on:click="keepOnBinding()">
                        Passer à la suite sans attacher
                    </p>
                </div>
                <div v-if="is_one_document" class="is_one_document">
                    IS ONE DOCUMENT, bind tout en un seul document !!!
                </div>
                <div class="incoherence" v-for="(incoherence) in multipleReferencesOnSameBoundDocument">
                    ⚠️ ERREUR : numéros de factures différents sur un groupe de pages ({{ incoherence.join(',') }})
                </div>
                <div class="incoherence" v-for="(incoherence) in sameReferenceOnSeveralBoundDocuments">
                    ⚠️ ERREUR : numéros de factures identiques sur 2 groupes de pages ({{ incoherence }})
                </div>
                <preview-toolbar @tile="change_display" :documentIds="documents"
                    :documentWithReferences="documents_with_references" :documentInFullDocs="documents_in_full_doc"
                    :unbind_all="unbind_all" :paths="paths" @unbound="unbounded_documents" ref="selector"
                    :key="JSON.stringify(documents)"
                    @updateReferenceIncoherences="update_references_incoherences" :isOneDocument="is_one_document" ></preview-toolbar>
            </b-col>
            <b-col cols="8">
                <div style="text-align: center">
                    <p>.</p>
                    <p>.</p>
                </div>
                <img id="main-image" ref="main-image" type="image/svg+xml" class="img-fluid" v-if="displayedHover"
                    :src="get_url_for_id" v-on:load="orientation_start()" />
            </b-col>
        </b-row>
    </b-container>
    <b-container v-else style="margin-top: 5rem;">
        <h2>STOP WORKING ! vous pouvez fermer cette fenêtre.</h2>
    </b-container>
</template>
<style scoped>
#main-image {
    max-width: 100%;
    max-height: 100%;
    background-color: transparent;
    cursor: zoom-in;
}

#main-imagebad {
    width: 100%;
    float: right;
    background-color: transparent;
    cursor: zoom-in;
}

#bind-batch {
    margin-top: 20px;
}

.incoherence {
    color: #DC3544;
    font-weight: 600;
    margin-top: 10px;
}
.is_one_document {
    color: rgb(195 5 5);
    font-size: 20px;
    font-weight: 600;
    text-decoration: underline;
}
</style>

<script>
import PreviewToolbar from "./preview_toobar.vue";
import axios from "axios";
export default {
    components: {
        PreviewToolbar,
    },
    data: function () {
        return {
            documents: [],
            documents_in_full_doc: [],
            documents_with_references: [],
            company_id: null,
            displayedHover: null,
            selectedDocuments: [],
            bind_error: null,
            binding: false,
            paths: [],
            tempo: null,
            rotation_angle: 0,
            scaling_value: 1,
            bind_waiting: null,
            first_orientation: true,
            unbind_all: false,
            multipleReferencesOnSameBoundDocument: [],
            sameReferenceOnSeveralBoundDocuments: [],
            get_next_to_bind: true,
            is_one_document: false
        };
    },
    computed: {
        batch_id: function () {
            return this.$route.params.id;
        },
        get_url_for_id: function () {
            //not loaded
            if (!this.paths.find((e) => e.id == this.displayedHover))
                return null;

            return this.paths.find((e) => e.id == this.displayedHover)[
                "get_cloudfront_signed_url"
            ];
        },
    },
    watch: {
        batch_id: function () {
            this.load_batch();
        },
        get_url_for_id() {
            this.get_orientation();
        },
    },
    mounted: function () {
        let token = document.head.querySelector(
            "[name~=csrf-token][content]"
        ).content;
        axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
        this.load_batch();
        this.init();
    },
    methods: {
        update_references_incoherences: function (incoherences) {
            this.multipleReferencesOnSameBoundDocument = incoherences.multipleReferencesOnSameBoundDocument;
            this.sameReferenceOnSeveralBoundDocuments = incoherences.sameReferenceOnSeveralBoundDocuments;
        },
        unbounded_documents: function (unbounded) {
            if (unbounded) {
                this.unbind_all = false;
            }
        },
        process_error: function (error) {
            console.log(error);
            this.binding = false;
            this.bind_error = error.response.data["error"];
        },
        change_display: function (item) {
            this.displayedHover = item;
        },
        load_next_batch: function (batch_id) {
            this.$router.push({ name: "BindBatch", params: { id: batch_id } });
        },
        return_to_bind: function () {
            this.$router.push({ name: "ClerkApplication"});
        },
        load_batch: function () {
            this.documents = [];

            //reset to get the correct first orientation of the image
            this.first_orientation = true;
            this.bind_waiting = "Chargement en cours, veuillez patienter ....";

            return axios
                .get(`/clerks/batch_info/${this.$route.params.id}`)
                .then((response) => {
                    let data = response.data;
                    this.documents = data["documents"];
                    this.paths = data["paths"];
                    this.company_id = data["company_id"];
                    this.bind_error = null;
                    this.binding = false;
                    this.bind_waiting = null;
                    this.documents_in_full_doc = data['documents_in_full_docs']
                    this.is_one_document = data['is_one_document']

                    axios
                        .put(`/clerks/look_for_ocr_infos_list`, {
                            documents: data["documents"]
                        }).then(response => {
                            this.documents_with_references = response.data
                        })
                })
                .catch(this.process_error);
        },
        keepOnBinding: function () {
            return axios
                .put(`/clerks/get_next_batch_to_bind`, {
                    company_id: this.company_id,
                })
                .then((response) => {
                    if (response.data.batch_id != null) {
                        this.load_next_batch(response.data.batch_id);
                    } else {
                        this.return_to_bind()
                    }
                });
        },
        init: function () {
            window.addEventListener("keydown", this.key_pressed, false);
        },
        orientation_start: function () {
            //put the correct orientation on the first image
            if (
                this.first_orientation != null &&
                Object.values(this.documents).length
            ) {
                //put the angle on the main image
                let path = this.paths.find(
                    (e) => e.id == this.displayedHover
                );
                if (!path) {
                    return;
                }
                let orientation_angle = 0;
                if (path["get_ocr_orientation_angle"]) {
                    let str_angle = path["get_ocr_orientation_angle"];
                    if (str_angle) {
                        try {
                            orientation_angle = JSON.parse(str_angle);
                        } catch (e) {
                            orientation_angle = 0;
                        }
                    }
                }

                //memorization for eventual rotations
                this.rotation_angle = parseInt(orientation_angle);

                if (this.$refs["main-image"]) {
                    //put the orientation angle on the main image
                    this.$refs["main-image"].style["transform"] =
                        "rotate(" + parseInt(orientation_angle) + "deg)";

                    //if the image is to prevent hidding the top of the image
                    if (this.rotation_angle % 180) {
                        this.$refs["main-image"].style["margin-top"] = "100px";
                    } else {
                        this.$refs["main-image"].style["margin-top"] = "0px";
                    }
                    this.first_orientation = null;
                }
            }
        },
        get_orientation: function () {
            //use the orientation angle of the file

            //not loaded
            let path = this.paths.find((e) => e.id == this.displayedHover);
            if (!path) {
                return null;
            }

            let orientation_angle = 0;
            if (path["get_ocr_orientation_angle"]) {
                let str_angle = path["get_ocr_orientation_angle"];
                if (str_angle) {
                    try {
                        orientation_angle = JSON.parse(str_angle);
                    } catch (e) {
                        orientation_angle = 0;
                    }
                }
            }

            //memorization for eventual rotations
            this.rotation_angle = parseInt(orientation_angle);

            //reset the scaling value
            this.scaling_value = 1;

            if (this.$refs["main-image"]) {
                //put the orientation angle on the main image
                this.$refs["main-image"].style["transform"] =
                    "rotate(" + parseInt(orientation_angle) + "deg)";

                if (this.rotation_angle % 180) {
                    this.$refs["main-image"].style["margin-top"] = "100px";
                } else {
                    this.$refs["main-image"].style["margin-top"] = "0px";
                }
            }
        },
        key_pressed: function (e) {
            //console.log('key pressed', e.key)

            if (e.key == "+") {
                this.doRotation(true);
            } else if (e.key == "-") {
                this.doRotation(false);
            } else if (e.key == "m") {
                this.doZoom(false);
            } else if (e.key == "p") {
                this.doZoom(true);
            } else if (e.key == "Escape") {
                this.doResetScaling();
            }
        },
        doResetScaling: function (on_left) {
            //put back the main image in a stable position, after many scalings
            this.scaling_value = 1;
            if (this.$refs["main-image"]) {
                this.$refs["main-image"].style["transform"] =
                    "scale(" +
                    this.scaling_value +
                    ") rotate(" +
                    this.rotation_angle +
                    "deg)";
                this.$refs["main-image"].style["cursor"] = "zoom-in";
            }
        },
        doRotation: function (on_left) {
            let angle = -90;
            if (!on_left) {
                angle = 90;
            }
            if (this.$refs["main-image"]) {
                this.rotation_angle = (this.rotation_angle + angle) % 360;
                this.$refs["main-image"].style["transform"] =
                    "rotate(" + this.rotation_angle + "deg)";
                if (this.rotation_angle % 180) {
                    this.$refs["main-image"].style["margin-top"] = "100px"; //margin-top: 100px
                } else {
                    this.$refs["main-image"].style["margin-top"] = "0px";
                }
            }
        },
        doZoom: function (on_plus) {
            let scale_increment = 0.2;
            if (!on_plus) {
                scale_increment = -0.2;
            }
            this.scaling_value += scale_increment;
            if (this.$refs["main-image"]) {
                this.$refs["main-image"].style["transform"] =
                    "scale(" +
                    this.scaling_value +
                    ") rotate(" +
                    this.rotation_angle +
                    "deg)";
                if (this.scaling_value > 1) {
                    this.$refs["main-image"].style["cursor"] = "zoom-in";
                } else if (this.scaling_value < 1) {
                    this.$refs["main-image"].style["cursor"] = "zoom-out";
                }
            }
        },
        checkIncoherencesAndBind: function (continue_binding) {
            if (this.is_one_document && JSON.stringify(this.$refs["selector"].bound[0]) !== JSON.stringify(this.documents) ){
                return `⚠️ ERREUR : IS ONE DOCUMENT doit être bind en un seul document ! `
            }
            const hasIncoherence = this.multipleReferencesOnSameBoundDocument.length > 0 || this.sameReferenceOnSeveralBoundDocuments.length > 0

            const multipleReferencesOnSameBoundDocumentText = this.multipleReferencesOnSameBoundDocument.map((incoherence) => {
                return `⚠️ ERREUR : numéros de factures différents sur un groupe de pages (${incoherence.join(',')})`
            })
            const sameReferenceOnSeveralBoundDocumentsText = this.sameReferenceOnSeveralBoundDocuments.map((incoherence) => {
                return `⚠️ ERREUR : numéros de factures identiques sur 2 groupes de pages (${incoherence})`
            })
            if (hasIncoherence) {
                if (window.confirm(`
                ${multipleReferencesOnSameBoundDocumentText}
                ${sameReferenceOnSeveralBoundDocumentsText}
                Voulez-vous continuer?"
                `)) {
                    this.bindBatch(continue_binding);
                }
            } else {
                this.bindBatch(continue_binding);
            }
        },
        bindBatch: function (continue_binding) {
            if (this.binding) return;
            this.binding = true;
            let selected_documents = this.$refs["selector"].bound;
            if (
                JSON.stringify(selected_documents.flat()) !=
                JSON.stringify(this.documents) ||
                this.documents.length === 0
            ) {
                this.binding = false;
                this.get_next_to_bind = true;
                this.bind_error = "Tous les documents n'ont pas été reliés!";
                return;
            }
            axios
                .put(`clerks/bind_batch/${this.batch_id}`, {
                    documents: selected_documents,
                })
                .then(() => {
                    this.get_next_to_bind = continue_binding
                    if (this.get_next_to_bind) {
                        this.keepOnBinding()
                    }
                })
                .catch(this.process_error);
        },
    },
};
</script>
